<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import mgr from "../../security/security.js";

export default {
  created: async function () {
    try {
      console.log("callback.vue start");
      var result = await mgr.signinRedirectCallback();
      var returnToUrl = "/";
      if (result.state !== undefined) {
        returnToUrl = result.state;
      }
      var user = await mgr.getUser();
      this.$store.commit("securityModule/setIsAuthenticated", true);
      this.$store.commit("securityModule/setUser", user);
      // both have to settle before the push below, or the router decides where
      // to send the user while access and roles are still unknown
      await this.$store.dispatch("securityModule/getUserAccess");
      //Here, dispatch whatever actions are necessary to load app specific user information
      await this.$store.dispatch("securityModule/getUserProfile");
      console.log("in callback - calling createOrUpdateUserSessionLog");
      this.$store.dispatch("securityModule/createOrUpdateUserSessionLog");
      this.$router.push({ path: returnToUrl });
      console.log("callback.vue end");
    } catch (e) {
      this.$store.commit("securityModule/setIsAuthenticated", false);
      this.$router.push({ name: "Error" });
    }
  },
};
</script>
